<template>

  <span :style="styles" :class="{paused:!!settings.paused,'link-with-icon-wrap':true}">

    <span class="link-with-icon pre-pause" v-if="settings.paused" title="This item is paused">
      <font-awesome-icon icon="pause-circle" class="svg" />
    </span>

    <router-link class="link-with-icon" :to="settings.link" v-if="typeof settings.link !== 'undefined' && typeof settings.newTab === 'undefined'">
      <span class="label" v-html="settings.label" />
      <font-awesome-icon :icon="settings.icon" class="svg" v-if="settings.icon !== ''&&!hideIcons" />
    </router-link>

    <a class="link-with-icon" :href="settings.link" target="_blank" v-if="typeof settings.link !== 'undefined' && typeof settings.newTab !== 'undefined'">
      <span class="label" v-html="settings.label" />
      <font-awesome-icon :icon="settings.icon" class="svg" v-if="settings.icon !== ''&&!hideIcons" />
    </a>

    <span class="link-with-icon click" v-if="typeof settings.click !== 'undefined' && ( typeof settings.icon2 === 'undefined' || settings.showIcon2 )" @click="clicked">
      <span class="label" v-html="settings.label" />
      <font-awesome-icon :icon="settings.icon" class="svg" v-if="settings.icon !== ''&&!hideIcons" />
    </span>

    <span class="link-with-icon icon2" v-if="settings.icon2&&!hideIcons" :title="settings.icon2Title">
      <font-awesome-icon :icon="settings.icon2" class="svg" @click="clicked(2)" :style="iconStyle('icon2')" />
    </span>

    <span class="link-with-icon icon3" v-if="settings.icon3&&!hideIcons" :title="settings.icon3Title">
      <font-awesome-icon :icon="settings.icon3" class="svg" @click="clicked(3)" :style="iconStyle('icon3')" />
    </span>

  </span>

</template>

<script>
import general from '../../utils/general';
export default {
  name: 'LinkWithIcon',
  props: {
    settings: {
      type: Object
    },
    hideIcons: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: function() {
        return {}
      }
    },
  },
  data() {
  	return {
  	  
  	}
  },
  methods: {

    clicked(n) {

      let s = general.stripObject(this.settings), c = 'clicked';
      
      if ( n && ( n === 2 || n === 3 ) && this.settings['action'+n] ) {

        s.eventOverride = this.settings['action'+n];

      }
      
      this.$emit(c,s);

    },
    iconStyle(type) {

      let s = {};
      
      if ( this.settings[type+'Colour'] ) s.color = this.settings[type+'Colour'];

      return s;

    }

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.link-with-icon-wrap {
  &.paused {
   
  }
}
.link-with-icon {
  
  font-size: inherit;
  text-decoration: none;
  cursor: pointer;
  &.icon2, &.icon3 {
    margin-left: 10px;
  }
  .label {

    display: inline-block;
    padding: 0 4px 0 0;
    color:@darkContrast;

  }

  .svg {

    height: 14px;
    color: @darkContrast;
    fill: @darkContrast;

  }

  &.pre-pause {

    cursor: default;
    margin-right: 2px;
    .svg {
      color: @formDefaultColour;
    }

  }

  &:hover {

    &:not(.pre-pause) {

      .label {

        color: @formDefaultColour;

      }

      .svg {
        color: @formDefaultColour;
        fill: @formDefaultColour;
      }

    }

  }

}
.link-with-icon-wrap {
  &.paused {
    .link-with-icon {
      opacity:0.5;
       &:hover {
        &:not(.pre-pause) {
        opacity:1;
        }
       }
    }
  }
}
</style>